export default __webpack_public_path__ + "static/media/fl.596d55a3.svg";